
import {  get, sendDelete, post, put } from '../helpers/api.helper';

export async function ListFichas(pageSize=0, page=0, paginated = false) {
    try {
        if(paginated)
            return await get(`ficha/pageSize=${pageSize}&page=${page}`);
        else
            return await get('ficha');
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function listPreCadastro(pageSize=0, page=0, paginated = false) {
    try {
        if(paginated)
            return await get(`preregistration/pageSize=${pageSize}&page=${page}`);
        else
            return await get('preregistration');
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function getRegistrationById(id) {
    try {
        return await get(`ficha/${id}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}


export async function deleteItem(id) {
    try {
        return await sendDelete(`ficha/${id}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function deleteItemPre(id) {
    try {
        return await sendDelete(`preregistration/${id}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function updateRegistration(body, id) {
    try {
        return await put(`ficha/${id}`, body);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function approveItem(id, item) {
    try {
        return await put(`ficha/approve/${id}`, item);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function reproveItem(id, reproveReason) {
    try {
        return await put(`ficha/reprove/${id}`, {...reproveReason});
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}


export async function createRegistration(body) {
    try {
        return await post(`ficha`, body);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function createPreRegistration(body) {
    try {
        return await post(`preregistration`, body);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function updatePreRegistration(body, id) {
    try {
        return await put(`preregistration/${id}`, body);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function approveItemPre(id, item) {
    try {
        return await put(`preregistration/approve/${id}`, item);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function reproveItemPre(id, reproveReason) {
    try {
        return await put(`preregistration/reprove/${id}`, {...reproveReason});
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}

export async function getPreRegistrationById(id) {
    try {
        return await get(`preregistration/${id}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}
